//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LazyHydrate from 'vue-lazy-hydration';

import {
  /* fetchEducation, */ fetchPositions,
} from '~/assets/js/services/sanity';
import { SITE_TITLE } from '~/assets/js/constants';
import { curriculumVitaeUrl } from '~/assets/js/urls';

let head;

if (process.server) {
  head = require('~/utilities/head').default;
}

export default {
  components: {
    LazyHydrate,
  },

  async asyncData({ error: nuxtError }) {
    // let education;
    let positions;

    try {
      [/* education,  */ positions] = await Promise.all([
        // fetchEducation(),
        fetchPositions(),
      ]);
    } catch (error) {
      console.error(error);

      nuxtError(500, error);
    }

    return { /* education, */ positions };
  },

  head() {
    if (process.server) {
      return head('curriculum-vitae');
    }

    return {
      title: `Curriculum Vitae | ${SITE_TITLE}`,

      link: [
        { hid: 'canonical', rel: 'canonical', href: curriculumVitaeUrl(true) },
      ],
    };
  },
};
